<div id="user-management-view" class="page-layout blank">
    <div class="content">
        <div class="left">
            <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <div class="widget" fxFlex="100" fxFlex.gt-sm="20">
                    <app-users-list (userChanged)="userClicked($event)"></app-users-list>
                </div>
                <div class="widget user-management-view" fxFlex="100" fxFlex.gt-sm="80">
                    <app-users-details [user]="selectedUser"></app-users-details>
                </div>
            </div>
        </div>
    </div>
</div>